import classnames from 'classnames';
import React from 'react';

import Button from 'common/components/Button';
import { IMG_SUGGESTIONS } from 'common/configuration/constants';
import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import eventEmitter from 'common/services/events/eventEmitter';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';
import { Origin } from 'common/tracking/types';

import BaseItem, { Props as BaseItemProps } from './BaseItem';
import SuggestionImage, {
  Props as SuggestionImageProps
} from './SuggestionImage';
import SuggestionLink from './SuggestionLink';
import styles from './styles.module.scss';

type Props = Pick<BaseItemProps, 'className'> &
  Pick<SuggestionImageProps, 'lazy'>;

const SpeednoterItem = ({ className, lazy }: Props) => {
  return (
    <BaseItem className={classnames(className, styles.speednoterItem)}>
      <SuggestionLink
        href={path('userspace_permanent_speednoter')}
        onClick={() => {
          eventEmitter.emit(
            TrackingEventNames.OPEN_PERMANENT_SPEEDNOTER_BUTTON_CLICK,
            Origin.BoosterThumbnail
          );
        }}
      >
        <SuggestionImage src={IMG_SUGGESTIONS} lazy={lazy} />
        <span className={styles.speednoterItemOverlay}>
          <p className={classnames(styles.speednoterItemText, 'font-1')}>
            {trans('rating-suggestions.speednoter.text')}
          </p>
          <Button size="sm" theme="social-ac" type="full">
            {trans('rating-suggestions.speednoter.cta')}
          </Button>
        </span>
      </SuggestionLink>
    </BaseItem>
  );
};

export default SpeednoterItem;
